import React, { useEffect, useState } from "react";
import "./InfoModal.scss";
import { InfoButton } from "./InfoButton/InfoButton";
import { InfoFragment } from "./InfoFragment/InfoFragment";
import { TakeALookButton } from "./TakeALookButton/TakeALookButton";
import { YearInfoContentImage } from "./InfoFragment/InfoFragmentImage/InfoFragmentImage";


interface EmissionYearInfo {
    emission: boolean;
    year: number;
    contents: {
        text: string;
        image?: YearInfoContentImage,
        imgPos?: 'left' | 'right',
    }[]
}

const contents: EmissionYearInfo[] = [
    {
        emission: false,
        year: 2020,
        contents: [{
            text: 'Let’s try to keep the\nworld as it is now!',
        }],
    },
    {
        emission: true,
        year: 2020,
        contents: [{
            text: 'Do you see\nthe cows?',
            image: 'cow',
            imgPos: 'left',
        }, {
            text: 'Keep your eye\non the road?',
        }, {
            text: 'Are the tulips\nin bloom?',
            image: 'tulip',
            imgPos: 'right',
        }],
    },
    {
        emission: false,
        year: 2025,
        contents: [{
            text: 'Let’s try to keep the\nworld as it is now!'
        }],
    },
    {
        emission: true,
        year: 2025,
        contents: [{
            text: 'Is the river\nfrozen?',
            image: 'iceSkaters',
            imgPos: 'left',
        }, {
            text: 'Are the\ncows cold?',
        }, {
            text: 'Are people ice\nskating and going to\nhe ‘koek & zopie’?',
        }],
    },
    {
        emission: false,
        year: 2030,
        contents: [{
            text: 'We’re doing\na great job!'
        }],
    },
    {
        emission: true,
        year: 2030,
        contents: [{
            text: 'Not much has\nchanged. We can\nstill do something!',
        }],
    },
    {
        emission: false,
        year: 2035,
        contents: [{
            text: 'We’re doing\na great job!'
        }],
    },
    {
        emission: true,
        year: 2035,
        contents: [{
            text: 'Did you see\nwhat happened\nto the snow?',
            image: 'snow',
            imgPos: 'left',
        }, {
            text: ' Is it still busy\non the lake?',
        }],
    },
    {
        emission: false,
        year: 2040,
        contents: [{
            text: 'Investments\nare paying off.'
        }, {
            text: 'What if we\nhad not made\nthese efforts?',
        }],
    },
    {
        emission: true,
        year: 2040,
        contents: [{
            text: 'Is the grass\nstill green?'
        }, {
            text: 'Do you see\nchanges in\nthe forest? ',
            image: 'deer',
            imgPos: 'left'
        }],
    },
    {
        emission: false,
        year: 2045,
        contents: [{
            text: 'Investments\nare paying off.'
        }, {
            text: 'What if we\nhad not made\nthese efforts?',
        }],
    },
    {
        emission: true,
        year: 2045,
        contents: [{
            text: 'Where did\nthe snow go?',
            image: 'snow',
            imgPos: 'right'
        }, {
            text: 'Do you see the\nfirst cracks\nforming in the ice? ',
        }],
    },
    {
        emission: false,
        year: 2050,
        contents: [{
            text: 'The world is\ndoing great!\nSo are you!'
        }],
    },
    {
        emission: true,
        year: 2050,
        contents: [{
            text: 'What is\nhappening\nto the road?'
        }, {
            text: 'Is there an ice\ncream truck?',
            image: 'iceCream',
            imgPos: 'left',
        }],
    },
    {
        emission: false,
        year: 2055,
        contents: [{
            text: 'The world is\ndoing great!\nSo are you!'
        }],
    },
    {
        emission: true,
        year: 2055,
        contents: [{
            text: 'Are they\nstill ice\nskating?',
            image: 'iceSkaters',
            imgPos: 'left',
        }],
    },
    {
        emission: false,
        year: 2060,
        contents: [{
            text: 'Making an\nimpact that\nmatters!'
        }],
    },
    {
        emission: true,
        year: 2060,
        contents: [{
            text: 'What happened\nto the forest?',
            image: 'deer',
            imgPos: 'right',
        }, {
            text: 'Is the river wider?'
        }, {
            text: 'Are the cows\nstill happy?',
            image: 'cow',
            imgPos: 'left',
        }],
    },
    {
        emission: false,
        year: 2065,
        contents: [{
            text: 'Making an\nimpact that\nmatters!'
        }],
    },
    {
        emission: true,
        year: 2065,
        contents: [{
            text: 'Where did\nthe snow go?',
            image: 'snow',
            imgPos: 'right',
        }],
    },
    {
        emission: false,
        year: 2070,
        contents: [{
            text: 'This is what\nwe are\ndoing it for!'
        }],
    },
    {
        emission: true,
        year: 2070,
        contents: [{
            text: 'What happened\nto the trees?',
            image: 'deer',
            imgPos: 'right',
        }, {
            text: 'Are the cows\nstill happy?',
            image: 'cow',
            imgPos: 'left',
        }, {
            text: 'What about\nthe people?',
        }],
    },
    {
        emission: false,
        year: 2075,
        contents: [{
            text: 'This is what\nwe are\ndoing it for!'
        }],
    },
    {
        emission: true,
        year: 2075,
        contents: [{
            text: 'What happened to\nthe ‘koek & zopie’?',
            image: 'zopie',
            imgPos: 'left',
        }, {
            text: 'How many cars\ndo you see?',
            image: 'car',
            imgPos: 'right',
        }],
    },
    {
        emission: false,
        year: 2080,
        contents: [{
            text: 'We sufficed!\nWe reshaped\nour world.'
        }],
    },
    {
        emission: true,
        year: 2080,
        contents: [{
            text: 'Will the cow\nsurvive?',
            image: 'cow',
            imgPos: 'right',
        }, {
            text: 'Are the\ncows cold?',
        }, {
            text: 'What happened\nto the river?',
            image: 'boat',
            imgPos: 'left',
        }],
    },
    {
        emission: false,
        year: 2085,
        contents: [{
            text: 'We sufficed!\nWe reshaped\nour world.'
        }],
    },
    {
        emission: true,
        year: 2085,
        contents: [{
            text: 'Wait!',
        }, {
            text: 'Is this\nsummer',
        }, {
            text: 'or winter?',
        }],
    },
];

interface IProps {
    year: number;
    emission: boolean;
    visible: boolean;
}

export function InfoModal({ year, emission, visible }: IProps) {
    const [showPopover, setShowPopover] = useState(false);

    const information = (contents.find(content => content.year === year && content.emission === emission) as EmissionYearInfo).contents;

    const classes = ['info-modal-wrapper', ...(showPopover ? ['visible'] : [])];

    useEffect(() => {
        if (!visible) {
            setShowPopover(false);
        }
    }, [visible]);

    return (
        <>
            <InfoButton visible={visible} onClick={() => {
                setShowPopover(true);
            }} />
            <div className={classes.join(' ')} onClick={() => {
                setShowPopover(false);
            }}>
                <div className="take-a-look-button-container">
                    <TakeALookButton onClick={() => setShowPopover(false)} visible={showPopover} />
                </div>
                <div className={`info-modal-inner length-${information.length}`}>
                    <React.Fragment>
                        {information.map((content, index: number) => {
                            return <InfoFragment info={content} visible={showPopover} key={index} />;
                        })}
                    </React.Fragment>
                    <TakeALookButton onClick={() => setShowPopover(false)} visible={showPopover} />
                </div>
            </div>
            {/*<Popover title={title} show={showPopover} onClose={() => {*/}
            {/*    setShowPopover(false)*/}
            {/*}}>*/}
            {/*    <p>*/}
            {/*        {content}*/}
            {/*    </p>*/}
            {/*    <Button onClick={() => {*/}
            {/*        setShowPopover(false)*/}
            {/*    }}>Take a look</Button>*/}
            {/*</Popover>*/}
        </>
    )
}
